module.exports = __webpack_public_path__ + "static/img/4.d2e15c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/eng/4.png
// module id = LVVV
// module chunks = 0